import React, { useRef, useState, useEffect, useContext } from "react";
import styles from "../EditProfile/EditProfile.module.css";
import Refferal from "../Refferal/Refferal";
import MySubscription from "../MySubscription/MySubscription";
import BillingInvoices from "../BillingInvoices/BillingInvoices";
import PaymentMethod from "../PaymentMethod/PaymentMethod";
import PaymentDue from "../PaymentDue/PaymentDue";
import {
  API_BASE_URL,
  getEndUserSubscriptions_Billings,
  getBillingInvoices,
  deleteUser,
  getUserDetails,
  LoginWithEmailOTP,
  updateEmailSendOtp,
  updateUserDetails,
  verifyEmailOTP,
  countAgentsbyUserId,
  getMyTeams,
  getSmsOptOutStatus, // ADDED
  updateSmsOptOutStatus, // ADDED
} from "../../Store/apiStore";
import UploadProfile from "../Popup/profilePictureUpdater/UploadProfile";
import decodeToken from "../../lib/decodeToken";
import {
  getActiveOwnerId,
  getActiveRole,
  getContextCount,
  isOwnContext,
} from "../../lib/activeContext";
import PopUp from "../Popup/Popup";
import useUser from "../../Store/Context/UserContext";
import { useNavigate, useLocation } from "react-router-dom";
import Loader2 from "../Loader2/Loader2";

import Loader from "../Loader/Loader";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isIndiaSite } from "../../utils/apiBackend";
import axios from "axios";
import { RefreshContext } from "../PreventPullToRefresh/PreventPullToRefresh";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import { useDashboardStore } from "../../Store/agentZustandStore";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import PushPermissionModal from "../PushPermissionModal/PushPermissionModal";
import { registerPushToken } from "../../utils/initNotificationSocket";
import { isNativeApp } from "../../utils/nativePermissions";
import detectPlatform from "../../utils/detectPlatform";

// Extra-minutes / PAYG-extra Stripe price differs per environment.
// Production uses the live "PAYG Extra" price; staging/dev use the
// "Extra Minutes" price. Driven by REACT_APP_ENV — the same flag the rest
// of the app uses to tell production from staging (see useIPRestriction.js).
const EXTRA_MINUTES_PRICE_ID =
  process.env.REACT_APP_ENV === "production"
    ? "price_1RvBOrSCQQfKS3WDNZNTpIHS" // PAYG Extra (production)
    : "price_1Rng5W4T6s9Z2zBzhMctIN38"; // Extra Minutes (staging / dev)

const EditProfile = () => {
  const { setHasFetched } = useDashboardStore();
  const fileInputRef = useRef(null);
  const sectionRef = useRef(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [popupMessage, setPopupMessage] = useState("");
  const token = localStorage.getItem("token");
  const decodeTokenData = decodeToken(token);
  const userId = decodeTokenData?.id;
  const activeOwnerId = getActiveOwnerId();
  const isOwner = isOwnContext();
  const activeRole = getActiveRole(); // "owner" | "admin" | "support"
  const isTeamMember = !isOwner;
  const canManageBilling = isOwner || activeRole === "admin";
  const showOwnerSections = isOwner;

  // Access can be granted WHILE someone is already signed in: the owner adds
  // them to a team and no token is reissued, so `contextCount` stays at
  // whatever it was at login — 1 for a plain account owner. Trusting the token
  // alone would mean the only way to discover new access is to log out and back
  // in. So ask the server once when this screen opens. One call on a rarely
  // opened screen, no polling.
  const [serverContexts, setServerContexts] = useState(0);
  useEffect(() => {
    let cancelled = false;
    getMyTeams()
      .then((d) => {
        if (cancelled) return;
        setServerContexts((d?.teams?.length || 0) + (d?.self?.available ? 1 : 0));
      })
      .catch(() => {
        /* soft-fail — the token-based checks below still apply */
      });
    return () => {
      cancelled = true;
    };
  }, []);
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const editProfileLocation = useLocation();
  // Allow callers to specify where to return after edit (e.g.
  // /fast-agent-detail vs /dashboard) via navigate('/edit-profile',
  // { state: { returnTo: '/fast-agent-detail' } }). Falls back to
  // /dashboard so legacy entry points keep working.
  const editProfileReturnTo =
    editProfileLocation?.state?.returnTo || "/fast-agent-detail";
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addLoading, addSetLoading] = useState(false);
  const [sendOtpLoading, setSendOtpLoading] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [showDashboardReferral, setShowDashboardReferral] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // Payg states
  const params = new URLSearchParams(window.location.search);
  const isPayg = params.get("isPayg");
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [customerId, setcustomerId] = useState();
  const [userId1, setuserId1] = useState();

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    profilePicture: "",
  });
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const [otpSent, setOtpSent] = useState(false);
  const [emailVerified, setEmailVerified] = useState(true);
  const [otpEmail, setOtpEmail] = useState("");
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [resendTimer, setResendTimer] = useState(60);
  const isOtpFilled = otp.every((digit) => digit !== "");
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const isRefreshing = useContext(RefreshContext);
  const [redirectButton, setRedirectButton] = useState(false);

  const [zapierVisible, setZapierVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [showDisableConfirmModal, setShowDisableConfirmModal] = useState(false);
  const [disableLoading, setDisableLoading] = useState(false);
  const [clientVisible, setClientVisible] = useState(false);
  const [copiedZapier, setCopiedZapier] = useState(false);
  const [copiedClient, setCopiedClient] = useState(false);
  const [showReferral, setShowReferral] = useState(true); // Default to showw

  useEffect(() => {
    async function checkLocation() {
      try {
        const res = await axios.get('https://ipinfo.io/json');
        const data = res.data;

        // Block if in Canada (country code 'CA')
        if (data.country === 'CA') {
          setShowReferral(false);
        }
      } catch (error) {
        console.warn('Geolocation check failed, showing icon by default:', error);
        // Fallback: keep showingcd
      }
    }

    checkLocation();
  }, []); // Run once on mount

  const openUploadModal = () => {
    setIsUploadModalOpen(true);
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isPayg1 = urlParams.get("isPayg");
  useEffect(() => {
    if (isPayg1 === "true") {
      localStorage.setItem("isPayg", true);
      setPaygEnabled(true);
      setPopupType("success");
      setPopupMessage("Pay As You Go Activated successfully.");
      setShowPopup(true);
    }
  }, []);

  const closeUploadModal = () => {
    setIsUploadModalOpen(false);
  };

  const handleUpload = (imageUrl) => {
    setUploadedImage(imageUrl);
    setFormData((prev) => ({
      ...prev,
      profilePicture: imageUrl,
    }));
  };

  const isDataChanged = () => {
    if (!initialData) return false;

    const { name, email, phone, address } = formData;
    const {
      name: initialName,
      email: initialEmail,
      phone: initialPhone,
      address: initialAddress,
    } = initialData;

    return (
      name !== initialName ||
      email !== initialEmail ||
      phone !== initialPhone ||
      address !== initialAddress
    );
  };
  const getEndUserSubscriptions = async () => {
    if (!canManageBilling || !activeOwnerId) return;
    try {
      const data = await getEndUserSubscriptions_Billings(activeOwnerId);
      // console.log("User subscription Data:", data);
      setSubscriptionDetails(data);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  /*
   * INVOICES ONLY come from Stripe.
   *
   * The `subscriptionsss` mirror updates the SAME row on every renewal, so it
   * can only ever show the latest charge — a customer a year in saw one
   * "invoice" instead of twelve, because the earlier ones were overwritten.
   * Stripe keeps every charge as its own immutable record, so the history is
   * actually the history.
   *
   * Everything else on this screen (My Subscriptions: plan, purchase date, next
   * billing date) deliberately still comes from getEndUserSubscriptions_Billings
   * and is untouched.
   */
  const [invoices, setInvoices] = useState([]);
  const [invoicesLoading, setInvoicesLoading] = useState(true);
  const [invoicesError, setInvoicesError] = useState("");

  const loadInvoices = async () => {
    if (!canManageBilling) {
      setInvoicesLoading(false);
      return;
    }
    try {
      const data = await getBillingInvoices();
      setInvoices(data?.invoices || []);
      setInvoicesError("");
    } catch (error) {
      console.error("Error fetching invoices:", error);
      setInvoicesError(
        error.message || "Couldn't load your invoices. Please try again."
      );
    } finally {
      setInvoicesLoading(false);
    }
  };

  const [zapApikey, setZapApikey] = useState("");
  const [clientId, setClientId] = useState("");
  const fetchUser = async () => {
    try {
      if (!isRefreshing) {
        setLoading(true);
      }

      const user = await getUserDetails(userId, token);

      setZapApikey(user?.ZapApikey);
      setClientId(user?.client_id);
      setcustomerId(user?.customerId);
      setuserId1(user?.userId);
      setReferralCode(user?.referralCode);
      setShowDashboardReferral(user?.showreferralfloating);
      localStorage.setItem("showreferralfloating", user?.showreferralfloating);
      /*
       * Profile-picture URL resolver.
       *
       * The DB stores profilePicture in two shapes:
       *   - Uploaded files: a server-relative path like
       *     "/public/uploads/profile_xxx.png". To render this in the
       *     browser we have to prepend the API host (sans `/api`) so
       *     the static file route is reachable: e.g.
       *     "https://api.host.com/uploads/profile_xxx.png".
       *   - OAuth pictures: a full absolute URL from Google
       *     (https://lh3.googleusercontent.com/...) which is already
       *     directly loadable — NO transform needed.
       *
       * The old code unconditionally ran the "split('public')[1]"
       * transform. On Google URLs there is no "public" substring, so
       * `split[1]` was `undefined` and the template literal produced
       * "https://api.host.comundefined" → broken <img src>, HeaderBar
       * onError fell through to the default icon, and users reported
       * their avatar "disappearing" after visiting EditProfile.
       *
       * Detect upload vs URL by looking for the "public" segment and
       * branch the transform accordingly. Uploads continue to work
       * exactly as before.
       */
      const resolveProfilePic = (raw) => {
        if (!raw) return "";
        if (typeof raw !== "string") return "";
        // Already a full URL (Google OAuth, CDN, etc.) — use as-is.
        if (/^https?:\/\//i.test(raw) && !raw.includes("public")) return raw;
        if (raw.includes("public")) {
          const tail = raw.split("public")[1];
          if (!tail) return raw;
          return `${API_BASE_URL?.split("/api")[0]}${tail}`;
        }
        // Path doesn't start with http and doesn't contain "public" —
        // best effort, return as-is so the <img onError> can fall
        // back to the default icon cleanly.
        return raw;
      };
      const profilePic = resolveProfilePic(user?.profilePicture);
      // Sync latest name & profile to Zustand store so dashboard also reflects updates
      setUser({ name: user.name || "", profile: profilePic || "" });
      setFormData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        address: user.address || "",
        profilePicture: profilePic,
      });
      setInitialData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        address: user.address || "",
        profilePicture: profilePic,
      });
    } catch (error) {
      console.error(error);
      alert("Failed to load user details.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUser();
  }, []);
  useEffect(() => {
    if (!userId || !canManageBilling) {
      setInvoicesLoading(false);
      // `{}`, not null — this state is initialised to `{}` and read all over
      // this component as a plain object (`subscriptionDetails.invoices` at the
      // PAYG lookup guards the .filter but not the object itself, so a null here
      // crashed the whole page for support members, who are exactly the users
      // this branch exists for).
      setSubscriptionDetails({});
      setInvoices([]);
      return;
    }
    getEndUserSubscriptions();
    loadInvoices();
  }, [userId, activeOwnerId, canManageBilling]);
  useEffect(() => {
    if (isRefreshing) {
      if (canManageBilling) {
        getEndUserSubscriptions();
        loadInvoices();
      }
      fetchUser();
    }
  }, [isRefreshing, canManageBilling]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email" && value !== initialData?.email) {
      setEmailVerified(false);
      setOtpSent(false);
      setOtp(["", "", "", "", "", ""]);
    }
    // Real-time name validation: only allow letters, spaces, hyphens, apostrophes
    if (name === "name") {
      if (value && !/^[a-zA-Z\s'-]*$/.test(value)) return;
      setErrors((prev) => ({ ...prev, name: "" }));
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSendOTP = async () => {
    try {
      setSendOtpLoading(true);
      await updateEmailSendOtp(formData.email, userId);
      setOtpSent(true);
      setOtpEmail(formData.email);
      setResendTimer(60);
      setIsResendDisabled(true);
      setShowPopup(true);
      setPopupType("success");
      setPopupMessage("One Time Password sent successfully!");
      const timerInterval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval);
            setIsResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      // alert("Failed to send OTP. Please try again.");
      if (error.status == 409) {
        // setEmailVerified(true);
        setOtpSent(false);
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage(
          error?.response?.data.error || "Failed to send OTP. Please try again."
        );
        setOtpSent(true);
      } else {
        setOtpSent(false);
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage(
          error?.response?.data.error || "Failed to send OTP. Please try again."
        );
      }
    } finally {
      setSendOtpLoading(false);
    }
  };
  const handleOtpChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handleVerifyOtp = async () => {
    try {
      setIsVerifyingOtp(true);
      const code = otp.join("");

      // API to verify
      const verified = await verifyEmailOTP(otpEmail, code); // <-- create this API

      if (verified) {
        setEmailVerified(true);
        setShowPopup(true);
        setPopupType("success");
        setPopupMessage("Email verified successfully!");
      } else {
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage("Incorrect OTP. Try again.");
      }
    } catch (err) {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage("Verification failed.");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Name Validation
    if (!formData.name || !formData.name.trim()) {
      newErrors.name = "Name is required.";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters.";
    } else if (formData.name.trim().length > 50) {
      newErrors.name = "Name must be less than 50 characters.";
    } else if (!/^[a-zA-Z\s'-]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can only contain letters, spaces, hyphens and apostrophes.";
    }
    // Conditional Email & Phone validation
    if (!formData.email && !formData.phone) {
      newErrors.email = "Email is required if phone is not provided.";
      newErrors.phone = "Phone is required if email is not provided.";
    } else {
      if (
        formData.email &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
      ) {
        newErrors.email = "Invalid email format.";
      }

      if (formData.phone) {
        try {
          const raw = formData.phone.startsWith("+")
            ? formData.phone
            : "+" + formData.phone;

          const parsed = parsePhoneNumberFromString(raw);

          if (!parsed || !parsed.isValid()) {
            newErrors.phone =
              "Enter a valid phone number for selected country.";
          }
        } catch (e) {
          newErrors.phone = "Invalid phone number.";
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      addSetLoading(true);

      const response = await updateUserDetails(userId, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
      });
      // console.log(response.user.profilePicture, "response42343243242");
      setUser({ name: formData?.name, profile: formData?.profilePicture });

      setInitialData({ ...formData });
      setShowPopup(true);
      setPopupType("success");
      setPopupMessage("Profile updated successfully!");
      setTimeout(() => {
        handleClosePopup();
      }, 2000);
      setIsEditing(false);
    } catch (error) {
      console.error(error);
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage("Failed to update profile.");
    } finally {
      addSetLoading(false);
    }
  };
  const handleClosePopup = () => {
    setShowPopup(false);
    setRedirectButton(false);
  };
  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else if (editProfileLocation?.state?.returnTo) {
      navigate(editProfileLocation.state.returnTo, { replace: true });
    } else if (isPayg === "true") {
      navigate("/fast-agent-detail", { replace: true });
    } else {
      navigate(editProfileReturnTo, { replace: true });
    }
  };
  const nevigate = useNavigate();

  const [paygEnabled, setPaygEnabled] = useState(
    localStorage.getItem("isPayg") || false
  );

  const [pushEnabled, setPushEnabled] = useState(false);
  const [showPushModal, setShowPushModal] = useState(false);

  // Owner ki setting hai — poori team ko dikhti hai, badal sirf owner sakta hai.
  const [smsPrefs, setSmsPrefs] = useState({
    newLead: false,
    meetingBooked: false,
    transferFailed: false,
  });
  const [smsPrefSaving, setSmsPrefSaving] = useState("");
  const [smsPrefsOpen, setSmsPrefsOpen] = useState(false);
  // Consent na ho to toggle on hone par bhi backend SMS nahi bhejta.
  const [smsConsent, setSmsConsent] = useState(true);

  useEffect(() => {
    if (!userId) return;
    getSmsOptOutStatus()
      .then((data) => {
        if (data?.smsPrefs) setSmsPrefs(data.smsPrefs);
        if (typeof data?.smsConsent === "boolean") setSmsConsent(data.smsConsent);
      })
      .catch((err) => console.error("Failed to fetch SMS opt-out status:", err));
  }, [userId]);

  const handleSmsPrefToggle = async (key, label) => {
    if (!isOwner || smsPrefSaving) return; // ADDED: owner-only guard
    const next = !smsPrefs[key];
    setSmsPrefSaving(key);
    try {
      const data = await updateSmsOptOutStatus({ [key]: next });
      if (data?.smsPrefs) setSmsPrefs(data.smsPrefs);
      setShowPopup(true);
      setPopupType("success");
      setPopupMessage(`${label} SMS ${next ? "enabled" : "disabled"}.`);
    } catch (err) {
      console.error("Failed to update SMS opt-out status:", err);
    } finally {
      setSmsPrefSaving("");
    }
  };

  const isAppEnvironment = () => {
    if (typeof window === "undefined") return false;
    const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
    return (
      isNativeApp() ||
      detectPlatform() === "android" ||
      detectPlatform() === "ios" ||
      /Android|iPhone|iPad|iPod/i.test(ua) ||
      !("Notification" in window)
    );
  };

  useEffect(() => {
    if (!userId) return;
    const fetchPushStatus = async () => {
      try {
        const response = await fetch(`${API_BASE}/push/status/${userId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setPushEnabled(!!data.pushEnabled);
        }
      } catch (err) {
        console.error("Failed to fetch push status:", err);
      }
    };
    fetchPushStatus();
  }, [userId, API_BASE, token]);

  const toggleMasterPushApi = async (enabled) => {
    try {
      const response = await fetch(`${API_BASE}/push/toggle-master`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ userId, enabled }),
      });
      if (response.ok) {
        setPushEnabled(enabled);
        setShowPopup(true);
        setPopupType("success");
        setPopupMessage(enabled ? "Push Notifications Enabled." : "Push Notifications Disabled.");
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handlePushToggle = async () => {
    if (pushEnabled) {
      // Want to turn OFF
      await toggleMasterPushApi(false);
      return;
    }

    // Want to turn ON
    const isApp = isAppEnvironment();
    if (isApp) {
      if (isNativeApp()) {
        setShowPushModal(true);
      } else {
        // Android WebView / Mobile without RN bridge:
        // Try to sync any stored FCM token and toggle master push ON
        const storedToken = localStorage.getItem("fcmToken");
        if (storedToken) {
          try {
            await registerPushToken(userId, storedToken, "android");
          } catch (_e) { }
        }
        await toggleMasterPushApi(true);
      }
    } else {
      // Desktop / Web browser
      if ("Notification" in window && Notification.permission === "granted") {
        await toggleMasterPushApi(true);
      } else {
        setShowPushModal(true);
      }
    }
  };

  const handlePushTokenReceived = async (fcmToken) => {
    try {
      const isActualToken = fcmToken && fcmToken !== "granted" && fcmToken !== "native_granted";
      if (isActualToken) {
        const platform = detectPlatform() === "ios" ? "ios" : (detectPlatform() === "android" ? "android" : "web");
        await registerPushToken(userId, fcmToken, platform);
      } else {
        const storedToken = localStorage.getItem("fcmToken");
        if (storedToken) {
          const platform = localStorage.getItem("fcmPlatform") || (detectPlatform() === "ios" ? "ios" : "android");
          await registerPushToken(userId, storedToken, platform);
        }
      }
      await toggleMasterPushApi(true);
    } catch (err) {
      console.error("Push token registration failed:", err);
    } finally {
      setShowPushModal(false);
    }
  };

  // const PaygSubscriptionId = subscriptionDetails.invoices
  //   ?.filter(invoice =>
  //     invoice.plan_name === "Extra Minutes"
  //     // invoice.plan_name === "PAYG Extra" // LIVE ACCOUNT
  //     && invoice.status !== "canceled") // Filter by plan and status
  //   .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort by latest created_at
  //   .map(invoice => invoice.subscription_id)[0]; // Get the subscription_id of the latest invoice
  // console.log("PaygSubscriptionId", subscriptionDetails.invoices)

  const PaygSubscriptionId = subscriptionDetails?.invoices
    ?.filter((invoice) => {
      // if (invoice.plan_name !== "Extra Minutes" || invoice.status === "canceled") {
      if (invoice.plan_name !== "PAYG Extra" || invoice.status === "canceled") {
        return false;
      }

      // Parse metadata safely
      let metadata = {};
      try {
        metadata =
          typeof invoice.metadata === "string"
            ? JSON.parse(invoice.metadata)
            : invoice.metadata || {};
      } catch (err) {
        console.error("Error parsing metadata:", err);
      }

      // Skip if assign_number_plan is true
      return metadata.assign_number_plan !== true;
    })
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // latest first
    .map((invoice) => invoice.subscription_id)[0]; // get first sub id

  const handlePaygToggle = async () => {
    const hasByAdminAgent =
      Array.isArray(subscriptionDetails?.agents) &&
      subscriptionDetails.agents.some((a) => a?.subscriptionId === "byAdmin");

    // console.log("subscriptionDetails",subscriptionDetails)

    // if (hasByAdminAgent) {
    //   // return
    // } else if (subscriptionDetails.invoices.length === 0) {
    //   setRedirectButton(true)
    //   setShowPopup(true);
    //   setPopupType("failed");
    //   setPopupMessage("To enable Pay As You Go, please ensure you have an active subscription.");
    //   return
    // }
    const isCurrentlyEnabled = paygEnabled;

    if (!isCurrentlyEnabled) {
      setShowConfirmModal(true); // Show confirmation modal first
      return;
    }

    if (isCurrentlyEnabled) {
      setShowDisableConfirmModal(true); // Show confirmation modal
      return;
    }

    if (isCurrentlyEnabled) {
      console.log("Cancel Run");
      try {
        const cancelResponse = await fetch(
          `${API_BASE}/cancel-subscription-schedule`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ subscriptionId: PaygSubscriptionId }),
          }
        );
        if (cancelResponse.ok) {
          localStorage.removeItem("isPayg");
          setShowPopup(true);
          setPopupMessage(
            "Your PAYG Stripe has been deactivated. All active PAYG agents will be disabled."
          );
          setPopupType("failed"); // Pop-up for disabled
          setPaygEnabled(false);

          // Step 3: Disable PAYG for all agents by calling the payg-agents-disabled API
          const disablePaygResponse = await fetch(
            `${API_BASE}/payg-agents-disabled`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ subscriptionId: PaygSubscriptionId }), // Assuming PaygSubscriptionId is related to customerId
            }
          );

          if (disablePaygResponse.ok) {
            console.log("✅ PAYG agents disabled successfully.");
          } else {
            console.log("❌ Failed to disable PAYG agents.");
          }
        }

        if (!cancelResponse.ok) {
          console.error("Failed to cancel the subscription schedule.");
          return;
        }
        // Subscription cancelled successfully, now proceed to disable PAYG
      } catch (error) {
        console.error("Error canceling subscription:", error);
        return;
      }
    } else {
      console.log("checkout Run");
      // console.log("d",window.location.origin)
      const currentUrl = window.location.origin;
      const requestData = {
        customerId: customerId,
        priceId: EXTRA_MINUTES_PRICE_ID, // prod → PAYG Extra, else → Extra Minutes
        promotionCode: "",
        userId: userId1,
        // agentId: agentID,
        url: `${currentUrl}/edit-profile?isPayg=true`,
        cancelUrl: `${currentUrl}/edit-profile?isPayg=false`,
        subscriptionId: PaygSubscriptionId,
      };

      try {
        const t = localStorage.getItem("t");
        if (t) {
          const response = await fetch(`${API_BASE}/payg-subscription-handle`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestData),
          });

          // console.log("response2222",response.json())

          if (response.ok) {
            const responseData = await response.json();
            if (responseData.checkoutUrl) {
              // localStorage.setItem("isPayg", true)
              window.location.href = responseData.checkoutUrl;
            } else if (responseData.subscription) {
              setShowPopup(true);
              console.log("resume Succesfully");
              setPopupMessage("Payg resume Succesfully ");
              setPopupType("success");
              localStorage.setItem("isPayg", true);
              setPaygEnabled(true);
            }

            console.log("API response:", responseData); // You can handle the API response heree
          } else {
            console.error("Failed to send the request");
          }
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const maskKey = (key) => "•".repeat(key?.length || 10);
  const handleEnablePaygConfirmed = async () => {
    setConfirmLoading(true);

    try {
      const currentUrl = window.location.origin;
      const requestData = {
        customerId,
        priceId: EXTRA_MINUTES_PRICE_ID, // prod → PAYG Extra, else → Extra Minutes
        promotionCode: "",
        userId: userId1,
        url: `${currentUrl}/edit-profile?isPayg=true`,
        cancelUrl: `${currentUrl}/edit-profile?isPayg=false`,
        subscriptionId: PaygSubscriptionId,
      };

      const response = await fetch(`${API_BASE}/payg-subscription-handle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      const responseData = await response.json();

      if (response.ok) {
        if (responseData.checkoutUrl) {
          window.location.href = responseData.checkoutUrl;
        } else if (responseData.subscription) {
          localStorage.setItem("isPayg", true);
          setPaygEnabled(true);

          // Close confirmation modal, open info popup
          setShowConfirmModal(false);
          setConfirmLoading(false);
          setPopupType("success");
          setPopupMessage("Pay As You Go resumed successfully.");
          setShowPopup(true);
        }
      } else {
        console.error("Failed to activate PAYG");
        setConfirmLoading(false);
      }
    } catch (error) {
      console.error("Error enabling PAYG:", error);
      setConfirmLoading(false);
    }
  };

  const handleDisablePaygConfirmed = async () => {
    setDisableLoading(true);
    try {
      const cancelResponse = await fetch(
        `${API_BASE}/cancel-subscription-schedule`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ subscriptionId: PaygSubscriptionId }),
        }
      );

      if (cancelResponse.ok) {
        localStorage.removeItem("isPayg");
        setPaygEnabled(false);

        const disablePaygResponse = await fetch(
          `${API_BASE}/payg-agents-disabled`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ subscriptionId: PaygSubscriptionId }),
          }
        );

        if (disablePaygResponse.ok) {
          console.log("✅ PAYG agents disabled successfully.");
        } else {
          console.log("❌ Failed to disable PAYG agents.");
        }

        // Close confirm modal, show final popup
        setShowDisableConfirmModal(false);
        setShowPopup(true);
        setPopupMessage(
          "Your PAYG subscription has been deactivated. All active PAYG agents are now disabled."
        );
        setPopupType("failed");
        setHasFetched(false);
      } else {
        console.error("Failed to cancel PAYG subscription.");
      }
    } catch (error) {
      console.error("Error canceling subscription:", error);
    } finally {
      setDisableLoading(false);
    }
  };

  // ─── Team Management ──────────────────────────────────────────
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamLoading, setTeamLoading] = useState(false);
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [showEditMemberModal, setShowEditMemberModal] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [memberForm, setMemberForm] = useState({
    name: "", email: "", phone: "", role: "support",
    permissions: { viewAgents: true, editAgents: false, dialer: false, viewCallLogs: true, viewAppointments: true, viewContacts: false },
  });
  const [memberFormErrors, setMemberFormErrors] = useState({});
  const [addMemberLoading, setAddMemberLoading] = useState(false);
  const [editMemberLoading, setEditMemberLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState(null);
  const [deleteMemberLoading, setDeleteMemberLoading] = useState(false);

  const defaultMemberForm = {
    name: "", email: "", phone: "", role: "support",
    permissions: { viewAgents: true, editAgents: false, dialer: false, viewCallLogs: true, viewAppointments: true, viewContacts: false },
  };

  const fetchTeamMembers = async () => {
    try {
      setTeamLoading(true);
      const res = await axios.get(`${API_BASE_URL}/team/members`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // permissions string ya object dono ho sakti hai — safe parse
      const members = (res.data.members || [])
        .map((m) => {
          let perms = m.permissions;
          if (typeof perms === "string") {
            try { perms = JSON.parse(perms); } catch { perms = {}; }
          }
          return { ...m, permissions: perms };
        });
      setTeamMembers(members);
    } catch (err) {
      console.error("fetchTeamMembers error:", err);
    } finally {
      setTeamLoading(false);
    }
  };

  useEffect(() => {
    if (showOwnerSections) fetchTeamMembers();
  }, [showOwnerSections]);

  const validateMemberName = (name) => {
    if (!name || !name.trim()) return "Name is required.";
    if (name.trim().length < 2) return "Name must be at least 2 characters.";
    if (name.trim().length > 50) return "Name must be less than 50 characters.";
    if (!/^[a-zA-Z\s'-]+$/.test(name.trim())) return "Name can only contain letters, spaces, hyphens and apostrophes.";
    return "";
  };

  const validateMemberPhone = (phone) => {
    if (!phone || !phone.trim()) return ""; // phone is optional
    try {
      const raw = phone.startsWith("+") ? phone : "+" + phone;
      const parsed = parsePhoneNumberFromString(raw);
      if (!parsed || !parsed.isValid()) {
        return "Enter a valid phone number for selected country.";
      }
    } catch (e) {
      return "Invalid phone number.";
    }
    return "";
  };

  const handleAddMember = async () => {
    const errs = {};
    const nameErr = validateMemberName(memberForm.name);
    if (nameErr) errs.name = nameErr;
    if (!memberForm.email) errs.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(memberForm.email))
      errs.email = "Invalid email format";
    const phoneErr = validateMemberPhone(memberForm.phone);
    if (phoneErr) errs.phone = phoneErr;
    setMemberFormErrors(errs);
    if (Object.keys(errs).length > 0) return;

    try {
      setAddMemberLoading(true);
      await axios.post(
        `${API_BASE_URL}/team/add-member`,
        {
          name: memberForm.name,
          email: memberForm.email,
          phone: memberForm.phone,
          role: memberForm.role,
          permissions: memberForm.permissions,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowAddMemberModal(false);
      setMemberForm({ ...defaultMemberForm });
      setMemberFormErrors({});
      setShowPopup(true);
      setPopupType("success");
      setPopupMessage("Team member added and notified via email!");
      fetchTeamMembers();
    } catch (err) {
      const msg = err?.response?.data?.error || "Failed to add team member";
      setMemberFormErrors({ api: msg });
    } finally {
      setAddMemberLoading(false);
    }
  };

  const openEditModal = (member) => {
    setEditingMember(member);
    // permissions string ya object dono ho sakti hai — safe parse
    let perms = member.permissions;
    if (typeof perms === "string") {
      try { perms = JSON.parse(perms); } catch { perms = {}; }
    }
    setMemberForm({
      name: member.name || "",
      email: member.email || "",
      phone: member.phone || "",
      role: member.role === "admin" ? "admin" : "support",
      permissions: {
        viewAgents: true,
        editAgents: !!perms?.editAgents,
        dialer: !!perms?.dialer,
        viewCallLogs: perms?.viewCallLogs !== false,
        viewAppointments: perms?.viewAppointments !== false,
        viewContacts: !!perms?.viewContacts,
      },
    });
    setMemberFormErrors({});
    setShowEditMemberModal(true);
  };

  const handleEditMember = async () => {
    const errs = {};
    const nameErr = validateMemberName(memberForm.name);
    if (nameErr) errs.name = nameErr;
    const phoneErr = validateMemberPhone(memberForm.phone);
    if (phoneErr) errs.phone = phoneErr;
    setMemberFormErrors(errs);
    if (Object.keys(errs).length > 0) return;

    try {
      setEditMemberLoading(true);
      await axios.put(
        `${API_BASE_URL}/team/members/${editingMember.id}`,
        {
          name: memberForm.name,
          phone: memberForm.phone,
          role: memberForm.role,
          permissions: memberForm.permissions,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowEditMemberModal(false);
      setEditingMember(null);
      setMemberForm({ ...defaultMemberForm });
      setShowPopup(true);
      setPopupType("success");
      setPopupMessage("Team member updated!");
      fetchTeamMembers();
    } catch (err) {
      const msg = err?.response?.data?.error || "Failed to update team member";
      setMemberFormErrors({ api: msg });
    } finally {
      setEditMemberLoading(false);
    }
  };

  const handleRemoveMember = (memberId) => {
    setDeletingMemberId(memberId);
    setShowDeleteConfirm(true);
  };

  const confirmDeleteMember = async () => {
    if (!deletingMemberId) return;
    try {
      setDeleteMemberLoading(true);
      await axios.delete(`${API_BASE_URL}/team/members/${deletingMemberId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setShowDeleteConfirm(false);
      setDeletingMemberId(null);
      setShowPopup(true);
      setPopupType("success");
      setPopupMessage("Team member deleted successfully!");
      fetchTeamMembers();
    } catch (err) {
      console.error("delete member error:", err);
      setShowPopup(true);
      setPopupType("error");
      setPopupMessage("Failed to delete team member.");
    } finally {
      setDeleteMemberLoading(false);
    }
  };

  const [togglingMemberId, setTogglingMemberId] = useState(null);
  const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
  const [deactivatingMember, setDeactivatingMember] = useState(null);
  const [deactivateLoading, setDeactivateLoading] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const isAnyModalOpen =
      showAddMemberModal ||
      showEditMemberModal ||
      showDeleteConfirm ||
      showDeactivateConfirm;

    const cardEl = cardRef.current;

    if (isAnyModalOpen) {
      const scrollY = window.scrollY;

      // Lock body
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";

      // Lock inner card scroll too (desktop fix)
      if (cardEl) {
        cardEl.style.overflow = "hidden";
      }
    } else {
      const scrollY = document.body.style.top;

      // Restore body
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }

      // Restore inner card scroll
      if (cardEl) {
        cardEl.style.overflow = "";
      }
    }

    return () => {
      const scrollY = document.body.style.top;
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
      if (cardEl) {
        cardEl.style.overflow = "";
      }
    };
  }, [showAddMemberModal, showEditMemberModal, showDeleteConfirm, showDeactivateConfirm]);

  const handleToggleClick = (member) => {
    if (member.status === "active") {
      // Deactivating → ask for confirmation
      setDeactivatingMember(member);
      setShowDeactivateConfirm(true);
    } else {
      // Activating → do it directly
      handleToggleMemberStatus(member.id);
    }
  };

  const confirmDeactivate = async () => {
    if (!deactivatingMember) return;
    setDeactivateLoading(true);
    await handleToggleMemberStatus(deactivatingMember.id);
    setDeactivateLoading(false);
    setShowDeactivateConfirm(false);
    setDeactivatingMember(null);
  };

  const handleToggleMemberStatus = async (memberId) => {
    try {
      setTogglingMemberId(memberId);
      const res = await axios.put(
        `${API_BASE_URL}/team/members/${memberId}/toggle-status`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowPopup(true);
      setPopupType("success");
      setPopupMessage(`Team member ${res.data.status === "active" ? "activated" : "deactivated"} successfully!`);
      fetchTeamMembers();
    } catch (err) {
      console.error("toggle status error:", err);
      setShowPopup(true);
      setPopupType("error");
      setPopupMessage("Failed to toggle member status.");
    } finally {
      setTogglingMemberId(null);
    }
  };
  // ──────────────────────────────────────────────────────────────

  const [glow, setGlow] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#payg-toggle") {
      // const el = document.getElementById("payg-toggle");
      // if (el) {
      //   el.scrollIntoView({ behavior: "smooth", block: "start" });
      // }
      setGlow(true);
      setTimeout(() => {
        sectionRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 0);
    }
  }, []);

  // #payment-method / #invoices (Outbound Caller's Usage & Billing rows): bring
  // that section to the top. Runs again as the sections above it finish loading
  // and push it down.
  useEffect(() => {
    const id = { "#payment-method": "payment-method", "#invoices": "invoices" }[editProfileLocation.hash];
    if (!id || loading) return undefined;
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
    return () => clearTimeout(timer);
  }, [editProfileLocation.hash, loading, invoicesLoading, subscriptionDetails]);

  const handleEditSection = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setFormData({ ...initialData }); // Reset form to original values
    setErrors({ name: "", email: "", phone: "", address: "" }); // Clear any errors
    setEmailVerified(true); // Reset email verification state
    setOtpSent(false);
    setOtp(["", "", "", "", "", ""]);
    // setIsEditing(false);
  };

  return (
    <>
      {loading ? (
        <Loader2 />
      ) : (
        <>
          <div className={styles.card} ref={cardRef}>
            <div className={styles.profileBack}>
              <div className={styles.backIcon}>
                <img
                  src="svg/Notification.svg"
                  alt="Back-icon"
                  className={styles.imageIcon}
                  onClick={handleBack}
                />
                <p>My Account</p>
              </div>

              <div className={styles.profilePic}>
                <button
                  onClick={openUploadModal}
                  className={styles.profilePicBtn}
                >
                  {formData?.profilePicture ? (
                    <img
                      src={uploadedImage || formData.profilePicture}
                      /*
                        Google's avatar CDN (lh3.googleusercontent.com)
                        returns 403 when the browser sends a Referer
                        for a domain not whitelisted on the OAuth
                        client. Without these two attributes the user's
                        Google profile pic "disappeared" after the
                        browser revalidated its cache. Mirrors the same
                        fix applied in HeaderBar.js.
                      */
                      referrerPolicy="no-referrer"
                      crossOrigin="anonymous"
                      onError={(e) => {
                        e.target.src = "/svg/profile-icon.svg";
                      }}
                      alt="Profile"
                    />
                  ) : (
                    <img
                      src={"/svg/profile-icon.svg"}
                      onError={(e) => {
                        e.target.src = "/svg/profile-icon.svg";
                      }}
                      alt="Profile"
                    />
                  )}

                  <span className={styles.editIcon}>
                    <img src="svg/edit-icon.svg" alt="edit" />
                  </span>
                </button>
              </div>
            </div>

            <div className={styles.allsectionDiv}>
              <div className={styles.infoSection}>
                <div className={styles.header}>
                  <h3>Personal Info</h3>
                  {isEditing ? (
                    <span className={styles.editText} onClick={handleCancel}>
                      <img
                        src="/svg/CrosSvg.svg" // You can change the icon if needed
                        className={styles.PurpolIcon}
                      />
                      Cancel
                    </span>
                  ) : (
                    <span
                      className={styles.editText}
                      onClick={handleEditSection}
                    >
                      <img
                        src="/svg/edit-icon2.svg"
                        className={styles.PurpolIcon}
                      />
                      Edit
                    </span>
                  )}
                </div>

                <div className={styles.Part}>
                  <img src="svg/line-Profile.svg" />
                  <div className={styles.infoItem}>
                    <label>Name <span className={styles.requiredStar}>*</span></label>
                    <input
                      type="text"
                      disabled={!isEditing}
                      name="name"
                      maxLength={50}
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      className={errors.name ? styles.inputBorderError : undefined}
                    />
                    {errors.name && (
                      <p className={styles.error}>{errors.name}</p>
                    )}
                    <hr className={styles.hrLine} />
                  </div>
                </div>

                <div className={styles.Part}>
                  <img src="svg/line-email.svg" />
                  <div className={styles.infoItem}>
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      readOnly
                    />
                    {errors.email && (
                      <p className={styles.error}>{errors.email}</p>
                    )}
                    <hr className={styles.hrLine} />
                  </div>
                </div>

                {!emailVerified && formData.email !== initialData?.email && (
                  <>
                    {/* Show Send OTP Button */}
                    {!otpSent && (
                      <div
                        className={styles.Btn}
                        onClick={() => {
                          if (
                            !formData.email ||
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                          ) {
                            setShowPopup(true);
                            setPopupType("failed");
                            setPopupMessage(
                              "Please enter a valid email before sending OTP."
                            );
                            return;
                          }
                          handleSendOTP();
                        }}
                      >
                        <div className={styles.btnTheme}>
                          <img src="svg/svg-theme.svg" alt="" />
                          <p>
                            {sendOtpLoading ? <Loader size={18} /> : "Send OTP"}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Show OTP Input UI if OTP sent */}
                    {otpSent && (
                      <>
                        {/* {formData.email && (
                        <p className={styles.codeText}>
                          Email has been sent to <strong>{formData.email}</strong>
                        </p>
                      )} */}
                        <p className={styles.codeText}>
                          Enter the code sent to your email
                        </p>
                        <br />
                        <div className={styles.otpContainer}>
                          {[...Array(6)].map((_, i) => (
                            <input
                              key={i}
                              maxLength="1"
                              value={otp[i]}
                              onChange={(e) =>
                                handleOtpChange(e.target.value, i)
                              }
                              className={styles.otpInput}
                              onKeyDown={(e) => handleKeyDown(e, i)}
                              ref={(el) => (inputRefs.current[i] = el)}
                              inputMode="numeric"
                              type="tel"
                            />
                          ))}
                        </div>

                        {/* Resend OTP */}
                        <div className={styles.resendContainer}>
                          <button
                            type="button"
                            onClick={handleSendOTP}
                            disabled={isResendDisabled}
                            className={`${styles.resendBtn} ${isResendDisabled ? styles.resendBtnDisabled : ""}`}
                          >
                            {isResendDisabled
                              ? `Resend OTP in ${String(
                                Math.floor(resendTimer / 60)
                              ).padStart(2, "0")}:${String(
                                resendTimer % 60
                              ).padStart(2, "0")}`
                              : "Resend OTP"}
                          </button>
                        </div>
                        {/* Verify Button */}
                        <div
                          className={`${styles.Btn} ${isOtpFilled && !isVerifyingOtp ? styles.actionEnabled : styles.actionDisabled}`}
                          onClick={
                            isOtpFilled && !isVerifyingOtp
                              ? handleVerifyOtp
                              : undefined
                          }
                        >
                          <div type="submit">
                            <div className={styles.btnTheme}>
                              <img src="svg/svg-theme.svg" alt="" />
                              <p>
                                {isVerifyingOtp ? (
                                  <Loader size={17} />
                                ) : (
                                  "Verify Email"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
                <div className={styles.Part}>
                  <img src="svg/line-Call.svg" />
                  <div className={styles.infoItem}>
                    <label>Phone Number</label>
                    <PhoneInput
                      country={isIndiaSite() ? "in" : "us"}
                      value={formData.phone}
                      disabled={!isEditing}
                      className={styles.phoneInput}
                      // Sirf is field ke flag ka border hatane ke liye.
                      containerClass={styles.profilePhoneNoFlagBorder}
                      onChange={(val) => {
                        setFormData((prev) => ({
                          ...prev,
                          phone: val,
                        }));
                        if (errors.phone) {
                          setErrors((prev) => ({ ...prev, phone: "" }));
                        }
                      }}
                      inputClass={errors.phone ? styles.inputError : ""}
                      inputProps={{
                        name: "phone",
                        required: true,
                        autoFocus: false,
                      }}
                    />
                    {errors.phone && (
                      <p className={styles.error}>{errors.phone}</p>
                    )}
                    <hr className={styles.hrLine} />
                  </div>
                </div>
                <div className={styles.Part}>
                  <img src="svg/line-address.svg" />
                  <div className={styles.infoItem}>
                    <label>Home address</label>
                    <textarea
                      name="address"
                      placeholder="Please enter address"
                      value={formData.address}
                      onChange={handleChange}
                      maxLength={10000}
                      disabled={!isEditing}
                    />
                    <hr className={styles.hrLine} />
                  </div>
                </div>
                <div
                  type="submit"
                  onClick={
                    isDataChanged() && !addLoading
                      ? formData.email === initialData?.email || emailVerified
                        ? handleSubmit
                        : () => {
                          setShowPopup(true);
                          setPopupType("failed");
                          setPopupMessage(
                            "Please verify your new email before saving."
                          );
                        }
                      : undefined
                  }
                  className={(() => {
                    // Opacity: data badla + (email same, ya naya email verified).
                    // Click: usme "save chal nahi raha" bhi.
                    const canSave =
                      isDataChanged() &&
                      (formData.email === initialData?.email ||
                        (formData.email !== initialData?.email && emailVerified));
                    return `${canSave ? "" : styles.dimmed} ${canSave && !addLoading ? styles.clickable : styles.noPointer}`;
                  })()}
                >
                  {isEditing && (
                    <div className={styles.btnTheme}>
                      <img src="svg/svg-theme.svg" alt="" />
                      <p>
                        {addLoading ? (
                          <>
                            Saving... &nbsp; <Loader size={18} />
                          </>
                        ) : (
                          "Save"
                        )}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {/* Workspace & Access — its own card, directly under the profile
                  details so it reads as "who I am" followed by "which account I am
                  working in", instead of being buried below billing. */}
              {(serverContexts > 1 || getContextCount() > 1 || isTeamMember) && (
                <div className={styles.infoSection}>
                  <div className={`${styles.header} ${styles.workspaceHeader}`}>
                    <h3>Workspace &amp; Access</h3>
                  </div>
                  <div
                    className={styles.workspaceRow}
                    onClick={() => navigate("/select-access?switch=1")}
                  >
                    <div className={styles.workspaceLeft}>
                      <img src="/svg/Integration-New.svg" alt="switch" className={styles.workspaceIcon} />
                      <div>
                        <div className={styles.workspaceTitle}>Switch Account / Workspace</div>
                        <div className={styles.workspaceSub}>Switch between your own workspace and team accounts</div>
                      </div>
                    </div>
                    <span className={styles.workspaceArrow}>&rarr;</span>
                  </div>
                </div>
              )}
              <div
                className={`${styles.infoSection} ${glow ? styles.glowOnce : ""
                  }`}
                ref={sectionRef}
                id="payg-toggle"
              >
                <div className={styles.toggleContainer1}>
                  <div className={styles.toggleTextAbove}>
                    Enable Push Notifications
                    {/* <p style={{ margin: "4px 0 0", fontSize: "10px", color: "#666", fontWeight: "400" }}>
                      Receive missed calls, spam, and usage alerts on this device
                    </p> */}
                  </div>
                  <label className={styles.toggleLabel1}>
                    <input
                      type="checkbox"
                      checked={pushEnabled}
                      onChange={handlePushToggle}
                      className={styles.toggleInput1}
                    />
                    <span
                      className={`${styles.toggleSlider1} ${pushEnabled ? styles.active1 : ""
                        }`}
                    />
                  </label>
                </div>
                {/* SMS Notifications — dropdown me teen alag toggle. Sabko
                    dikhte hain, badal sirf owner (isOwner) sakta hai. */}
                <hr className={styles.notifDivider} />
                <div
                  className={`${styles.toggleContainer1} ${styles.smsPrefsHeader}`}
                  role="button"
                  tabIndex={0}
                  aria-expanded={smsPrefsOpen}
                  onClick={() => setSmsPrefsOpen((open) => !open)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setSmsPrefsOpen((open) => !open);
                    }
                  }}
                >
                  <div className={styles.toggleTextAbove}>SMS Notifications</div>
                  {/* Chevron text ke andar nahi — container flex space-between
                      hai, to sibling rakhne se ye right edge par upar wale
                      toggles ke saath align ho jaata hai. */}
                  <span
                    aria-hidden="true"
                    className={`${styles.smsPrefsChevron} ${smsPrefsOpen ? styles.smsPrefsChevronOpen : ""}`}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {/* Default dropdown arrow — neeche; khulne par CSS upar ghuma deta hai. */}
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </div>

                {smsPrefsOpen && !smsConsent && (
                  <div className={styles.smsConsentNote}>
                    SMS consent pending — these are saved, but no SMS is sent until you
                    agree to receive messages.
                  </div>
                )}

                {smsPrefsOpen && (
                  <div className={styles.smsPrefsList}>
                    {[
                      { key: "newLead", label: "New Lead" },
                      { key: "meetingBooked", label: "Meeting Booked" },
                      { key: "transferFailed", label: "Transfer Failed" },
                    ].map(({ key, label }) => (
                      <div
                        key={key}
                        className={styles.smsPrefsRow}
                      >
                        <div className={styles.smsPrefsLabel}>{label}</div>
                        <label
                          className={styles.toggleLabel1}
                          style={!isOwner ? { cursor: "not-allowed", opacity: 0.6 } : undefined}
                          title={!isOwner ? "Only the account owner can change this setting" : undefined}
                        >
                          <input
                            type="checkbox"
                            checked={!!smsPrefs[key]}
                            onChange={() => handleSmsPrefToggle(key, label)}
                            disabled={!isOwner || !!smsPrefSaving}
                            className={styles.toggleInput1}
                          />
                          <span
                            className={`${styles.toggleSlider1} ${smsPrefs[key] ? styles.active1 : ""
                              }`}
                          />
                        </label>
                      </div>
                    ))}
                  </div>
                )}
                {/*
                  PAYG enable toggle — commented out, feature no longer in use.
                  <hr style={{ margin: "20px 0", borderTop: "1px solid #eee", borderBottom: "none" }} />
                  <div className={styles.toggleContainer1}>
                    <div className={styles.toggleTextAbove}>
                      Enable Pay as you go Feature
                    </div>
                    <label className={styles.toggleLabel1}>
                      <input
                        type="checkbox"
                        checked={paygEnabled}
                        onChange={fdfdfdhandlePaygToggle}
                        className={styles.toggleInput1}
                      />
                      <span
                        className={`${styles.toggleSlider1} ${paygEnabled ? styles.active1 : ""
                          }`}
                      />
                    </label>
                  </div>
                  */}
              </div>
              {/* ─── Team Management Section — for account owners, incl. an
                     admin team member who has created their own agent (they can
                     build a team for their OWN agent). ─── */}
              {showOwnerSections && (
                <div className={`${styles.infoSection} ${styles.teamSection}`}>
                  <div className={`${styles.header} ${styles.teamHeader}`}>
                    <h3>My Team</h3>
                    <button
                      className={styles.addMemberBtn}
                      onClick={() => { setMemberForm({ ...defaultMemberForm }); setMemberFormErrors({}); setShowAddMemberModal(true); }}
                    >
                      <span className={styles.addMemberPlus}>+</span>
                      Add Member
                    </button>
                  </div>

                  {teamLoading ? (
                    <p className={styles.teamLoadingText}>Loading...</p>
                  ) : teamMembers.length === 0 ? (
                    <p className={styles.teamEmptyText}>
                      No team members yet. Add your first team member above.
                    </p>
                  ) : (
                    <div className={styles.teamList}>
                      {teamMembers.map((m) => (
                        <div key={m.id} className={`${styles.teamCard} ${m.status === "deactivated" ? styles.teamCardInactive : ""}`}>
                          <div className={styles.teamCardLeft}>
                            <div className={styles.teamAvatar}>
                              {(m.name || m.email)[0].toUpperCase()}
                            </div>
                            <div className={styles.teamMemberInfo}>
                              <p className={styles.teamMemberName}>{m.name || "—"}</p>
                              <p className={styles.teamMemberEmail}>{m.email}</p>
                              {m.phone && <p className={styles.teamMemberPhone}>{m.phone}</p>}
                              <div className={styles.teamBadges}>
                                {m.role === "admin" ? (
                                  <span className={`${styles.badge} ${styles.badgeAdmin}`}>
                                    Admin · Full Access
                                  </span>
                                ) : (
                                  <>
                                    <span className={`${styles.badge} ${styles.badgeView}`}>View Agents</span>
                                    {m.permissions?.editAgents && (
                                      <span className={`${styles.badge} ${styles.badgeEdit}`}>Edit Agents</span>
                                    )}
                                    {m.permissions?.dialer && (
                                      <span className={`${styles.badge} ${styles.badgeDialer}`}>Dialer</span>
                                    )}
                                    {m.permissions?.viewCallLogs !== false && (
                                      <span className={`${styles.badge} ${styles.badgeCallLogs}`}>View Call Logs</span>
                                    )}
                                    {m.permissions?.viewAppointments !== false && (
                                      <span className={`${styles.badge} ${styles.badgeAppointments}`}>View Appointments</span>
                                    )}
                                    {m.permissions?.viewContacts && (
                                      <span className={`${styles.badge} ${styles.badgeView}`}>View Contacts</span>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className={styles.teamCardRight}>
                            <div className={styles.teamToggleWrap}>
                              <label
                                className={styles.teamToggle}
                                title={m.status === "active" ? "Deactivate member" : "Activate member"}
                              >
                                <input
                                  type="checkbox"
                                  checked={m.status === "active"}
                                  disabled={togglingMemberId === m.id}
                                  onChange={() => handleToggleClick(m)}
                                />
                                <span className={styles.teamToggleTrack} />
                              </label>
                              <span className={`${styles.statusBadge} ${m.status === "active" ? styles.statusActive : styles.statusDeactivated}`}>
                                {m.status === "active" ? "Active" : "Deactivated"}
                              </span>
                            </div>
                            {m.status === "active" && (
                              <div className={styles.teamCardActions}>
                                <button onClick={() => openEditModal(m)} title="Edit member" className={styles.teamEditBtn}>
                                  <img src="/svg/edit-icon3.svg" alt="edit-icon3" />
                                </button>
                                <button onClick={() => handleRemoveMember(m.id)} title="Remove member" className={styles.teamDeleteBtn}>
                                  <img src="/svg/delete-icon3.svg" alt="delete-icon3" />
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Add / Edit Member Modal */}
              {(showAddMemberModal || showEditMemberModal) && (
                <div
                  className={styles.teamModalOverlay}
                  onClick={() => { setShowAddMemberModal(false); setShowEditMemberModal(false); }}
                >
                  <div className={styles.teamModalBox} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.teamModalHeader}>
                      <h3 className={styles.teamModalTitle}>
                        {showEditMemberModal ? "Edit Team Member" : "Add Team Member"}
                      </h3>
                      <button
                        onClick={() => { setShowAddMemberModal(false); setShowEditMemberModal(false); setMemberFormErrors({}); setMemberForm({ ...defaultMemberForm }); }}
                        className={styles.teamModalClose}
                      >×</button>
                    </div>

                    <div className={styles.teamFormGroup}>
                      {/* Role dropdown — sits above everything so the owner
                            picks the access level first (Support vs Admin). */}
                      <div>
                        <label className={styles.teamFormLabel}>
                          Role <span className={styles.requiredStar}>*</span>
                        </label>
                        <select
                          value={memberForm.role}
                          onChange={(e) => setMemberForm((p) => ({ ...p, role: e.target.value }))}
                          className={`${styles.teamFormInput} ${styles.teamFormSelect}`}
                        >
                          <option value="support">Support — choose specific permissions</option>
                          <option value="admin">Admin — full access &amp; billing</option>
                        </select>
                      </div>

                      <div>
                        <label className={styles.teamFormLabel}>
                          Name <span className={styles.requiredStar}>*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter name"
                          value={memberForm.name}
                          onChange={(e) => {
                            setMemberForm((p) => ({ ...p, name: e.target.value }));
                            setMemberFormErrors((p) => ({ ...p, name: "" }));  // clear error on type
                          }}
                          className={`${styles.teamFormInput} ${memberFormErrors.name ? styles.teamFormInputError : ""}`}
                        />
                        {memberFormErrors.name && (
                          <p className={styles.teamFieldError}>
                            {memberFormErrors.name}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className={styles.teamFormLabel}>
                          Email <span className={styles.requiredStar}>*</span>
                        </label>
                        <input
                          type="email"
                          placeholder="Enter email"
                          value={memberForm.email}
                          disabled={showEditMemberModal}
                          onChange={(e) => { setMemberForm((p) => ({ ...p, email: e.target.value })); setMemberFormErrors((p) => ({ ...p, email: "" })); }}
                          className={`${styles.teamFormInput} ${memberFormErrors.email ? styles.teamFormInputError : ""}`}
                        />
                        {memberFormErrors.email && (
                          <p className={styles.teamFieldError}>{memberFormErrors.email}</p>
                        )}
                      </div>

                      <div className={styles.teamPhoneField}>
                        <label className={styles.teamFormLabel}>Phone</label>
                        <PhoneInput
                          country={isIndiaSite() ? "in" : "us"}
                          value={memberForm.phone}
                          onChange={(val) => { setMemberForm((p) => ({ ...p, phone: val })); setMemberFormErrors((p) => ({ ...p, phone: "" })); }}
                          inputClass={styles.teamPhoneInput}
                          buttonClass={styles.teamPhoneButton}
                          placeholder="Enter phone number"
                          enableSearch
                        />
                      </div>

                      {/* Admins get everything — no per-permission toggles to show */}
                      {memberForm.role === "admin" ? (
                        <div className={styles.adminAccessBox}>
                          <p className={styles.adminAccessTitle}>
                            Full access
                          </p>
                          <p className={styles.adminAccessText}>
                            Admins can view and edit agents, use the dialer, view call logs, appointments
                            &amp; contacts, and upgrade or pay for agents — just like you. No restrictions apply.
                          </p>
                        </div>
                      ) : (
                        /* Permissions Checkboxes (Support role only) */
                        <div>
                          <label className={styles.permLabel}>Permissions</label>
                          <div className={styles.permList}>
                            <label className={`${styles.permItem} ${styles.permItemStatic}`}>
                              <input type="checkbox" checked={true} disabled className={styles.permCheckbox} />
                              <span className={styles.permTextDisabled}>View Agents <span className={styles.permAlwaysOn}>(always on)</span></span>
                            </label>
                            <label className={styles.permItem}>
                              <input
                                type="checkbox"
                                checked={memberForm.permissions.editAgents}
                                onChange={(e) => setMemberForm((p) => ({ ...p, permissions: { ...p.permissions, editAgents: e.target.checked } }))}
                                className={styles.permCheckbox}
                              />
                              <span className={styles.permText}>Edit Agents</span>
                            </label>
                            <label className={styles.permItem}>
                              <input
                                type="checkbox"
                                checked={memberForm.permissions.dialer}
                                onChange={(e) => setMemberForm((p) => ({ ...p, permissions: { ...p.permissions, dialer: e.target.checked } }))}
                                className={styles.permCheckbox}
                              />
                              <span className={styles.permText}>Dialer Access</span>
                            </label>
                            <label className={styles.permItem}>
                              <input
                                type="checkbox"
                                checked={memberForm.permissions.viewCallLogs}
                                onChange={(e) => setMemberForm((p) => ({ ...p, permissions: { ...p.permissions, viewCallLogs: e.target.checked } }))}
                                className={styles.permCheckbox}
                              />
                              <span className={styles.permText}>View Call Logs</span>
                            </label>
                            <label className={styles.permItem}>
                              <input
                                type="checkbox"
                                checked={memberForm.permissions.viewAppointments}
                                onChange={(e) => setMemberForm((p) => ({ ...p, permissions: { ...p.permissions, viewAppointments: e.target.checked } }))}
                                className={styles.permCheckbox}
                              />
                              <span className={styles.permText}>View Appointments</span>
                            </label>
                            {/* Contacts sirf dekhne aur call karne ke liye — support add/edit nahi kar sakta. */}
                            <label className={styles.permItem}>
                              <input
                                type="checkbox"
                                checked={memberForm.permissions.viewContacts}
                                onChange={(e) => setMemberForm((p) => ({ ...p, permissions: { ...p.permissions, viewContacts: e.target.checked } }))}
                                className={styles.permCheckbox}
                              />
                              <span className={styles.permText}>View Contacts</span>
                            </label>
                          </div>
                        </div>
                      )}

                      {memberFormErrors.api && (
                        <p className={styles.teamApiError}>{memberFormErrors.api}</p>
                      )}

                      <button
                        onClick={showEditMemberModal ? handleEditMember : handleAddMember}
                        disabled={showEditMemberModal ? editMemberLoading : addMemberLoading}
                        className={styles.teamSubmitBtn}
                      >
                        {showEditMemberModal
                          ? (editMemberLoading ? "Saving..." : "Save Changes")
                          : (addMemberLoading ? "Adding..." : "Add Member")
                        }
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Delete Confirmation Dialog */}
              {showDeleteConfirm && (
                <div
                  className={styles.deleteModalOverlay}
                  onClick={() => { if (!deleteMemberLoading) { setShowDeleteConfirm(false); setDeletingMemberId(null); } }}
                >
                  <div className={styles.deleteModalBox} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.deleteModalIcon}>
                      <span className={styles.warnIconDanger}>&#9888;</span>
                    </div>
                    <h3 className={styles.deleteModalTitle}>Delete Team Member?</h3>
                    <p className={styles.deleteModalText}>
                      Are you sure you want to delete this member? This action is permanent and cannot be undone.
                    </p>
                    <div className={styles.deleteModalBtns}>
                      <button
                        onClick={() => { setShowDeleteConfirm(false); setDeletingMemberId(null); }}
                        disabled={deleteMemberLoading}
                        className={styles.deleteModalCancelBtn}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={confirmDeleteMember}
                        disabled={deleteMemberLoading}
                        className={styles.deleteModalConfirmBtn}
                      >
                        {deleteMemberLoading ? "Deleting..." : "Delete"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Deactivate Member Confirmation Dialog */}
              {showDeactivateConfirm && deactivatingMember && (
                <div
                  className={styles.deleteModalOverlay}
                  onClick={() => { if (!deactivateLoading) { setShowDeactivateConfirm(false); setDeactivatingMember(null); } }}
                >
                  <div className={styles.deleteModalBox} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.deleteModalIcon}>
                      <span className={styles.warnIconAmber}>&#9888;</span>
                    </div>
                    <h3 className={styles.deleteModalTitle}>Deactivate Team Member?</h3>
                    <p className={styles.deleteModalText}>
                      Are you sure you want to deactivate <strong>{deactivatingMember.name || deactivatingMember.email}</strong>? They will be logged out immediately and won't be able to access the account until you reactivate them.
                    </p>
                    <div className={styles.deleteModalBtns}>
                      <button
                        onClick={() => { setShowDeactivateConfirm(false); setDeactivatingMember(null); }}
                        disabled={deactivateLoading}
                        className={styles.deleteModalCancelBtn}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={confirmDeactivate}
                        disabled={deactivateLoading}
                        className={`${styles.deleteModalConfirmBtn} ${styles.deactivateConfirmBtn}`}
                      >
                        {deactivateLoading ? "Deactivating..." : "Yes, Deactivate"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Zapier Section */}
              {/* <div className={styles.infoSection} style={{ marginTop: '20px' }}>
                <div className={styles.toggleTextAbove} style={{ marginBottom: '8px' }}>
                  Get your Zapier key & Client Key
                  <i
                    onClick={() => setZapierVisible(!zapierVisible)}
                    style={{ cursor: 'pointer', marginLeft: '20px' }}
                    title={zapierVisible ? 'Hide Key' : 'Show Key'}
                    className={`fas ${zapierVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                  ></i>
                  {zapierVisible && (
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(zapApikey);
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                      }}
                      style={{
                        padding: '5px 10px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        background: '#f5f5f5',
                        fontSize: '12px',
                        cursor: 'pointer',
                        position: "absolute",
                        right: "0px",
                        top: "2px"
                      }}
                    >
                      {copied ? 'Copied!' : 'Copy'}
                    </button>
                  )}
                </div>
                <div className={styles.toggleContainer1}>
                  {zapierVisible && (
                    <div
                      style={{
                        borderRadius: '5px',
                        fontFamily: 'monospace',
                        wordBreak: 'break-all',
                      }}
                    >
                      <div style={{ marginTop: '5px' }}>
                        {zapApikey}
                      </div>
                    </div>
                  )}
                </div>
              </div> */}

              <div className={styles.RefferalMain}></div>
              {/* <br></br> */}
              {/* Sits ABOVE the plan card on purpose: when a renewal fails the
                    agent is deactivated, so paying is the most urgent thing on
                    this screen. Renders nothing when nothing is owed. */}
              {canManageBilling && (
                <>
                  <PaymentDue
                    invoices={invoices}
                    onPaid={async () => {
                      // The webhook is what reactivates the agent, so re-read both
                      // the invoice list and the subscription rows rather than
                      // patching skktate locally and hoping they agree.
                      await Promise.all([loadInvoices(), getEndUserSubscriptions()]);
                    }}
                  />
                  <div className={styles.mySubscription}>
                    <MySubscription
                      agents={subscriptionDetails?.agents || []}
                      onChanged={getEndUserSubscriptions}
                    />
                  </div>
                  {/* Self-serve card update — sits between the plan and the
                        receipts because that is the order people reason about
                        billing: what am I on, what card pays for it, what have
                        I been charged. */}
                  <div id="payment-method" className={styles.paymentMethod}>
                    <PaymentMethod />
                  </div>
                  <div id="invoices" className={styles.billingInvoice}>
                    <BillingInvoices
                      invoices={invoices}
                      loading={invoicesLoading}
                      error={invoicesError}
                    />
                  </div>
                </>
              )}
              {/* Referral and Keys & Credentials sit at the bottom of the
                    owner block: a promo and a developer detail respectively,
                    so neither should interrupt the plan → card → invoices
                    billing sequence above. */}
              {showOwnerSections && showReferral && (
                <div className={styles.RefferalMain}>
                  <Refferal
                    referralCode={referralCode}
                    setShowDashboardReferral={setShowDashboardReferral}
                    showDashboardReferral={showDashboardReferral}
                    userId={userId}
                  />
                </div>
              )}
              {showOwnerSections && (
                <div className={styles.keysSection}>
                  <h2 className={styles.heading}>Keys & Credentials</h2>
                  <br />

                  {/* Client Key Section */}
                  <div
                    className={`${styles.keyContainer} ${styles.keyContainerSpaced}`}
                  >
                    <div
                      className={`${styles.toggleTextAbove} ${styles.keyLabel}`}
                    >
                      Client Id
                      <i
                        onClick={() => setClientVisible(!clientVisible)}
                        title={clientVisible ? "Hide Key" : "Show Key"}
                        className={`${styles.keyEyeIcon} fas ${clientVisible ? "fa-eye-slash" : "fa-eye"
                          }`}
                      ></i>
                    </div>
                    <div
                      className={styles.keyValueBox}
                    >
                      <span>{clientVisible ? clientId : maskKey(clientId)}</span>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(clientId);
                          setCopiedClient(true);
                          setTimeout(() => setCopiedClient(false), 2000);
                        }}
                        disabled={!clientVisible}
                        className={`${styles.keyCopyBtn} ${copiedClient ? styles.keyCopyBtnCopied : ""}`}
                        title={clientVisible ? "Copy" : "Show the key to copy it"}
                      >
                        {!clientVisible ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
                            <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                        ) : copiedClient ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        ) : (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="2" />
                            <path d="M5 15V5a1 1 0 0 1 1-1h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                        )}
                        {copiedClient ? "Copied!" : "Copy"}
                      </button>
                    </div>
                  </div>

                  {/* Zapier Key Section */}
                  <div className={styles.keyContainer}>
                    <div
                      className={`${styles.toggleTextAbove} ${styles.keyLabel}`}
                    >
                      Zap Key
                      <i
                        onClick={() => setZapierVisible(!zapierVisible)}
                        title={zapierVisible ? "Hide Key" : "Show Key"}
                        className={`${styles.keyEyeIcon} fas ${zapierVisible ? "fa-eye-slash" : "fa-eye"
                          }`}
                      ></i>
                    </div>
                    <div
                      className={styles.keyValueBox}
                    >
                      <span>
                        {zapierVisible ? zapApikey : maskKey(zapApikey)}
                      </span>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(zapApikey);
                          setCopiedZapier(true);
                          setTimeout(() => setCopiedZapier(false), 2000);
                        }}
                        disabled={!zapierVisible}
                        className={`${styles.keyCopyBtn} ${copiedZapier ? styles.keyCopyBtnCopied : ""}`}
                        title={zapierVisible ? "Copy" : "Show the key to copy it"}
                      >
                        {!zapierVisible ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
                            <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                        ) : copiedZapier ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        ) : (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="2" />
                            <path d="M5 15V5a1 1 0 0 1 1-1h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                        )}
                        {copiedZapier ? "Copied!" : "Copy"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Help & Support — Documentation + FAQ show to everyone (incl. Team
                  Members); Agent Setup + Support Ticket stay owner-only. */}
              <div
                className={`${styles.helpSection} ${!showOwnerSections ? styles.helpSectionMember : ""}`}
              >
                <h2 className={styles.heading}>Help & Support</h2>
                <div className={styles.helpGrid}>
                  {[
                    { icon: "/svg/agent-setup.svg", label: "Agent Setup", path: "/agent-setup", ownerOnly: true },
                    { icon: "/svg/Support-ticket.svg", label: "Support Ticket", path: "/raise-tickets", ownerOnly: true },
                    { icon: "/svg/document.svg", label: "Documentation", path: "/documentation" },
                    // { icon: "/svg/Faq.svg", label: "FAQ", path: "https://www.rexpt.in/FAQ", external: true },
                  ].filter((item) => showOwnerSections || !item.ownerOnly).map((item) => (
                    <div
                      key={item.label}
                      className={styles.helpItem}
                      onClick={() => item.external ? window.open(item.path, "_blank") : navigate(item.path)}
                    >
                      <img src={item.icon} alt={item.label} className={styles.helpItemIcon} />
                      <span className={styles.helpItemLabel}>{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
              {showOwnerSections && (
                <div className={styles.deleteSection}>
                  <button
                    className={styles.deleteButton}
                    onClick={() => navigate("/delete-account")}
                  >
                    <img src="/svg/delete-icon.svg" alt="delete" />
                    Delete Profile
                  </button>
                </div>
              )}
            </div>
          </div>
          {isUploadModalOpen && (
            <UploadProfile
              onClose={closeUploadModal}
              onUpload={handleUpload}
              currentProfile={
                uploadedImage ||
                formData.profilePicture ||
                "Images/editProfile.png"
              }
            />
          )}
        </>
      )}
      {showPopup && (
        <PopUp
          type={popupType}
          onClose={() => handleClosePopup()}
          message={popupMessage}
          extraButton={
            redirectButton
              ? {
                label: "Redirect",
                onClick: () => navigate("/fast-agent-detail"),
              }
              : undefined
          }
        />
      )}

      <ConfirmModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        title="Enable Pay As You Go"
        message="Enabling Pay As You Go gives your account unlimited flexibility — no more minute caps. Once your current plan minutes are used, you can activate/deactivate PAYG for your agents, and billing will start based on usage."
        type="info"
        confirmText={confirmLoading ? "Processing..." : "Yes"}
        cancelText="Later"
        showCancel={true}
        isLoading={confirmLoading}
        onConfirm={handleEnablePaygConfirmed}
      />

      <ConfirmModal
        show={showDisableConfirmModal}
        onClose={() => setShowDisableConfirmModal(false)}
        title="Disable Pay As You Go?"
        message="Are you sure you want to disable Pay As You Go? All active PAYG agents will be deactivated immediately. Your final bill will be generated at the end of your current PAYG billing cycle and will be automatically deducted from your account."
        type="warning"
        confirmText={disableLoading ? "Disabling..." : "Yes, Disable"}
        cancelText="Cancel"
        showCancel={true}
        isLoading={disableLoading}
        onConfirm={handleDisablePaygConfirmed}
      />

      {showPushModal && (
        <PushPermissionModal
          forceOpen={true}
          onTokenReceived={handlePushTokenReceived}
          onClose={() => setShowPushModal(false)}
        />
      )}
    </>
  );
};

export default EditProfile;
//